<template>
    <div>
        <div class="product__items" :class="'products-'+view + ' products-' + mode">

            <div v-if="products.length && mode === 'cart'">
                <div class="centered__item about__intro text-center">
                    <h3>{{ $t('products.cart') }}</h3>
                    <div>
                        <span class="primary-lighter">
                            {{ $tc('products.products', cartQty.amount) }}
                        </span>
                        <template v-if="$store.getters['Auth/isAuthenticated']">
                            - {{ cartQty.price | priceformat }}
                        </template>
                    </div>
                    <br />
                    <router-link v-if="$store.getters['Auth/isAuthenticated']" to="/checkout/" tag="button">{{ $t('products.order_place') }}</router-link>
                    <router-link v-else to="/checkout/" tag="button">{{ $t('products.request_quote') }}</router-link>
                    <router-link :to="{ name: 'products', params: { mode: 'products' }}" tag="button" class="button_white">{{ $t('products.back_to_products') }}</router-link>
                </div>

            </div>

            <!-- list-header, with view-buttons -->
            <div v-if="products.length" class="c pi__header flex -space-between">
                <h3 v-if="mode === 'cart'">{{ $t('products.cart') }}</h3>
                <span v-else></span>

                <ul class="text-right">
                    <!-- <li>
                        <span class="fa">&#xf02f;</span>
                    </li> -->
                    <li :class="{ '-is-active': view === 'grid' }" @click="$emit('view', 'grid')">
                        <span class="fa">&#xf009;</span>
                    </li>
                    <li :class="{ '-is-active': view === 'list' }" @click="$emit('view', 'list')">
                        <span class="fa">&#xf0ca;</span>
                    </li>
                </ul>
            </div>

            <div class="c productscontainer">
                <!-- products -->
                <ul class="products" v-if="products.length">
                    <slide-y-up-transition group>
                        <Product
                            v-for="product in products"
                            :key="'product_' + (mode === 'products' ? product.id: product.product.id)"
                            :data="product"
                            :cart-map="cartMap[`item_${(mode === 'products' ? product.id : product.product.id)}`]"
                            :mode="mode"
                            :view="view"
                            :showCartForGuests="showCartForGuests"
                            >
                        </Product>
                        <InViewTrigger v-if="isPaginated" :key="'trigger'" :margin="200" @intersected="$emit('loadMore')"></InViewTrigger>
                    </slide-y-up-transition>
                </ul>
                <div v-else-if="!loading" class="fadeInUp flex -wrap -justify-center">

                    <!-- empty state -->
                    <div class="centered__item text-center">
                        <img src="/img/crown.svg" class="crown" /><br />
                        <h2 class="primary">{{ $t('errors.no_products.title') }}</h2>
                        <div v-if="mode === 'products'" class="primary-light size-4">{{ $t('errors.no_products.text') }}</div>
                        <div v-else-if="mode === 'cart'" class="primary-light size-4">{{ $t('errors.no_products.text_cart') }}</div>
                    </div>

                </div>
                <transition name="fade">
                    <div v-if="loading" class="loader -is-fixed">
                        <!-- loader -->
                        <span class="fa rotate page-is-loading">&#xf110;</span>
                    </div>
                </transition>

                <div class="text-right cart--total" v-if="products.length && mode === 'cart' && $store.getters['Auth/isAuthenticated']">
                    <div class="flex -justify-end text-right">
                        <div class="primary-lighter">
                            {{ $t('products.total') }}
                        </div>
                        <div class="size-4">{{ cartQty.price | priceformat }}</div>
                    </div>
                    <router-link v-if="$store.getters['Auth/isAuthenticated']" to="/checkout/" tag="button">{{ $t('products.order_place') }}</router-link>
                </div>

            </div>

        </div>
        <Related v-if="mode === 'cart'" v-bind="{ view, cartMap, items: related, showCartForGuests }" />
    </div>
</template>

<script>
import { SlideYUpTransition } from 'vue2-transitions';
import Product from '@/views/products/Product.vue';
import Related from '@/views/products/Related.vue';
import InViewTrigger from '@/components/InViewTrigger.vue';

export default {
    name: 'ProductList',
    components: {
        InViewTrigger, Product, SlideYUpTransition, Related,
    },
    props: {
        cartMap: Object,
        mode: String,
        view: {
            type: String,
            default: 'list',
        },
        loading: Boolean,
        related: Array,
        items: Array,
        isPaginated: Boolean,
        showCartForGuests: Boolean,
    },
    computed: {
        products() {
            return this.items || this.$store.getters['Products/products'](this.mode);
        },

        cartQty() {
            return this.$store.getters['Products/cartQty'];
        },
    },
};
</script>

<style>
    .cart--total .flex > div:not(:last-child) { margin-right: var(--padding-xxl); }
    .cart--total button  { margin-top: var(--padding); }
    .cart--total { margin: var(--padding-xxl) auto 0; }
</style>
